import React from "react";
import Loader from "../../components/loader";
import { t } from "../../../../dev/helpers/translator";
import { Field } from "redux-form";
import { getErrorMessageByCode } from "../../../../dev/constants/errorCodes";
import CustomComponent from "./pices/customComponent";

export default function loginFormTemplate() {
	console.debug("login form props", this.props);

	/**
	 * @name displayLoginFailReason
	 * @description get user login response and return message of result
	 * @param {object} reason
	 * @returns {undefined}
	 * */
	let displayLoginFailReason = reason => {
		console.log("login fail reason:", reason);
		if (!reason.data) {
			return reason.msg ? t(reason.msg) : t("Unknown error");
		}
		return getErrorMessageByCode(reason.data.status);
	};
	return [
		<form onSubmit={this.props.handleSubmit(this.doLogin)}>
			<div className="popup-contain-table-m login-form-m">
				<div className="center-view-contain-form">
					<div className="mini-logo-view">
						<div className="mini-logo-container" />
					</div>
					<div className="form-contain-box">
						<Field
							id="login-name"
							component={CustomComponent}
							className="single-form-item"
							type="text"
							name="login-name"
							placeholder={t("Login or email")}
						/>
						<Field
							id="password"
							component={CustomComponent}
							className="single-form-item"
							type="password"
							name="password"
							placeholder={t("Password")}
						/>
						{(this.props.user.profileError || this.props.user.loginFailReason) && (
							<div className="login-error">
								<span>
									{this.props.user.profileError
										? t(this.props.user.profileError)
										: t(
												displayLoginFailReason(
													this.props.user
														.loginFailReason
												)
										  )}
								</span>
							</div>
						)}
						<div className="separator-box-buttons-m">
							<button
								className="button-view-normal-m"
								disabled={
									this.props.submitting ||
									this.props.pristine ||
									!this.props.valid
								}
								type="submit"
							>
								{t("Login")}
							</button>
						</div>
					</div>
				</div>
			</div>
		</form>,
		this.props.user.loginInProgress && <Loader component="loginForm" />,
	];
}
